// extracted by mini-css-extract-plugin
export var assigneeBadge = "_kq-0";
export var assigneeDetails = "_kq-1";
export var assigneeInfo = "_kq-2";
export var dropdownContainer = "_kq-4";
export var dropdownImage = "_kq-5";
export var editAssigneeInfo = "_kq-3";
export var editAssigneeModalContainer = "_kq-6";
export var hidden = "_kq-8";
export var input = "_kq-7";